import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

export const SUPPORTED_LANGUAGES = ['en', 'fr'] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

// Auto-load every JSON file under locales/<lang>/ and merge into one resource
// bundle per language. Each file holds a distinct top-level namespace, so a
// shallow merge is sufficient.
const enModules = import.meta.glob('./locales/en/*.json', { eager: true });
const frModules = import.meta.glob('./locales/fr/*.json', { eager: true });

function mergeModules(modules: Record<string, unknown>): Record<string, unknown> {
  return Object.values(modules).reduce<Record<string, unknown>>((acc, mod) => {
    const content = (mod as { default?: Record<string, unknown> }).default ?? mod;
    return { ...acc, ...(content as Record<string, unknown>) };
  }, {});
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: mergeModules(enModules) },
      fr: { translation: mergeModules(frModules) },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'stratmined_lang',
      caches: ['localStorage'],
    },
  });

export default i18n;
